let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9gXki"), load("3g3yi")]).then(() => parcelRequire('bBPzK'));